// Central auth-token storage.
// sessionStorage is used instead of localStorage so tokens do not persist across
// browser sessions, shrinking the window for XSS token theft. All reads/writes go
// through this module so the storage mechanism can be swapped (e.g. for httpOnly
// cookies) in one place.
const TOKEN_KEY = "lookbook_token";

export const getToken = () => {
  let token = sessionStorage.getItem(TOKEN_KEY);
  if (!token) {
    // One-time migration for sessions created before the storage hardening.
    const legacy = localStorage.getItem(TOKEN_KEY);
    if (legacy) {
      sessionStorage.setItem(TOKEN_KEY, legacy);
      localStorage.removeItem(TOKEN_KEY);
      token = legacy;
    }
  }
  return token;
};

export const setToken = (token) => {
  sessionStorage.setItem(TOKEN_KEY, token);
};

export const clearToken = () => {
  sessionStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_KEY);
};
